import { render, staticRenderFns } from "./HospitalExchangeRate.vue?vue&type=template&id=6ede47ee&scoped=true"
import script from "./HospitalExchangeRate.vue?vue&type=script&lang=js"
export * from "./HospitalExchangeRate.vue?vue&type=script&lang=js"
import style0 from "./HospitalExchangeRate.vue?vue&type=style&index=0&id=6ede47ee&prod&scoped=true&lang=css"
import style1 from "./HospitalExchangeRate.vue?vue&type=style&index=1&id=6ede47ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ede47ee",
  null
  
)

export default component.exports